import React, { useEffect, useState } from "react";
import LoginHeaderOperational from "./LoginHeaderOperational";
import Sidebar_Progress from "../layouts/Operational_Sidebar_Progress.component";
import { API_URL } from "../../constant/API_Settings";
import FinancialStatementsPanel from "./FinancialStatementsPanel";
import { isOwnerRole } from "../../utils/ownerRole";

/**
 * Financial Statements page — owner-only, under Reports → Financial Reports.
 */
const FinancialStatements = (props) => {
  const [access, setAccess] = useState({ allowed: false, message: "Checking access…" });

  useEffect(() => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
      Accept: "application/json",
    };

    Promise.all([
      fetch(`${API_URL}/check_url`, {
        method: "post",
        headers,
        body: JSON.stringify({ pathurl: window.location.pathname }),
      }).then((r) => r.json()),
      fetch(`${API_URL}/is_owner`, { method: "get", headers }).then((r) => r.json()),
    ])
      .then(([urlData, roleName]) => {
        const isOwner = isOwnerRole(roleName);
        if (!isOwner) {
          setAccess({
            allowed: false,
            message: "Financial Statements are available to pump owners only.",
          });
          return;
        }
        if (urlData.allowurl != 1) {
          setAccess({
            allowed: false,
            message: "This screen is not available for your current setup.",
          });
          return;
        }
        setAccess({ allowed: true, message: "" });
      })
      .catch(() => {
        setAccess({
          allowed: false,
          message: "Unable to verify access. Please try again.",
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="main-container page-wrap">
      <div className="d-md-flex">
        <Sidebar_Progress props={props} progress={29} operation={4} op={3} />
        <div className="content-area">
          <LoginHeaderOperational props={props} page_title="" />
          {!access.allowed ? (
            <div className="form-wrap mt-5">
              <div className="text-center">{access.message}</div>
            </div>
          ) : (
            <div className="container pb-3">
              <div className="row justify-content-center mt-3 form-container">
                <div className="col-md-12">
                  <FinancialStatementsPanel
                    sectionId="financial-statements-page"
                    ownerVerified
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FinancialStatements;
